import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AngularMaterialModule } from 'src/app/material.module';
import { BaseComponent } from '@lib/components';
import { IError, ICustomer } from '@lib/interfaces';
import { IAccountTransferTransaction, ISenderInfo } from '@lib/interfaces/super-agent-transfer.interface';
import { AccountsService } from '@lib/services';
import { currencyDecimals, exportElementToPdf, formatPhoneNumber, maskFullName } from '@lib/utils';

@Component({
    selector: 'app-transfer-result',
    standalone: true,
    templateUrl: './transfer-result.component.html',
    styleUrls: ['./transfer-result.component.scss'],
    imports: [AngularMaterialModule],
})
export class TransferResultComponent extends BaseComponent {
    transaction?: IAccountTransferTransaction;
    recipientInfo: ICustomer;
    senderInfo: ISenderInfo;
    isMoneySent: boolean;
    errorDetails?: IError;

    @ViewChild('pdfExport', { static: false }) pdfExport: ElementRef;

    constructor(private readonly dialogRef: MatDialogRef<TransferResultComponent>, private readonly accountsService: AccountsService) {
        super();
    }

    protected get maskedRecipientName(): string {
        return maskFullName(this.recipientInfo.first_name, this.recipientInfo.last_name);
    }

    protected get formattedRecipientMobile(): string {
        return formatPhoneNumber(this.recipientInfo.mobile);
    }

    protected get formattedSenderMobile(): string {
        return formatPhoneNumber(this.senderInfo?.mobile);
    }

    protected get amountDecimals(): string {
        return currencyDecimals(this.transaction?.currency ?? '');
    }

    protected get total(): number {
        return (this.transaction?.amount ?? 0) + (this.transaction?.fee_amount ?? 0);
    }

    protected downloadReceipt(): void {
        exportElementToPdf(this.pdfExport.nativeElement, 'top-up-for-agent-receipt.pdf');
    }

    protected done(): void {
        if (this.isMoneySent) {
            this.accountsService.reloadWalletList.emit(true);
        }
        this.dialogRef.close();
    }
}
